import router from "../index";

export default function isClient({next, store}) {
    // console.log(store.getters.auth);
    let user = store.getters.getUser;
    if (user) {
        if (store.state.user.type === 'admin') {
            return next();
        } else {
            localStorage.removeItem('ptoken')
            store.dispatch('logout_user');
            return router.push({name: 'Login'});
        }
    }
    return next()
}